import { render, staticRenderFns } from "./ProductSelectionForms.vue?vue&type=template&id=0dd4799a&scoped=true"
import script from "./ProductSelectionForms.vue?vue&type=script&setup=true&lang=js"
export * from "./ProductSelectionForms.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd4799a",
  null
  
)

export default component.exports